<template>
  <div :class="`loading-modal ${loadingModalVisible}`">
    <div class="loading-modal-content">
      Now Loading ... <font-awesome-icon icon="spinner" spin />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'loadingModal',
    components: {},
    computed: {
      loadingModalVisible () {
        return this.$store.state.loadingModalVisible ? '': 'hidden'
      },
    }
  }
</script>

<style>
.loading-modal {
  z-index: 50;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: #fff;
  opacity: 0.6;
  padding: 20px;
  border-radius: 4px;
  margin: 0 auto;
  overflow: scroll;
}
.loading-modal.hidden {
  display: none;
}
.loading-modal-content {
  font-weight: bold;
  font-size: 2em;
  letter-spacing: 0.5ch;
  position: relative;
  text-align: center;
  height: 80%;
  width: 400px;
  height: 50px;
  margin: 230px auto auto auto;
}
</style>

